import React from "react";
import { Heading } from "../../design/heading";
import { Text } from "../../design/text";
import { Card } from "../../design/card";
import { Button } from "../../design/button";
import { useCustodyEvent } from "../../contexts/CustodyEventContext";
import CustodyCalendar from "./components/CustodyCalendar";
import moment from "moment";
import LoadingView from "../../components/LoadingView";
import ErrorView from "../../components/ErrorView";
import { useMatter } from "../../contexts/MatterContext";
import CustodyTasks from "./components/CustodyTasks";
import { useParentingPlan } from "../../contexts/ParentingPlanContext";
import { useChildSupportOrder } from "../../contexts/ChildSupportOrderContext";
import { useChildSupportPayment } from "../../contexts/ChildSupportPaymentContext";
import CurrentParentingPlan from "./components/CurrentParentingPlan";
import NextExchangeComponent from "./components/NextExchangeComponent";
import NextHolidayComponent from "./components/NextHolidayComponent";
import CurrentCustodyOrder from "./components/CurrentCustodyOrder";
import { CustodyEventDialogProvider } from "../../providers/CustodyEventDialogProvider";

const CustodyParentingIndex: React.FC = () => {
  const { loading, error } = useCustodyEvent();

  if (loading.list) return <LoadingView title="Loading Custody Events..." />;
  if (error.list) return <ErrorView error={error.list} />;

  return (
    <CustodyEventDialogProvider>
      <div className="py-4 space-y-6">
        <div className="grid grid-cols-1 gap-6 lg:grid-cols-3">
          <NextExchangeComponent />
          <NextHolidayComponent />
          <CurrentCustodyOrder />
        </div>

        <div className="grid grid-cols-1 gap-6 lg:grid-cols-2">
          <CurrentParentingPlan />
          <CustodyTasks />
        </div>

        <CustodyCalendar />
      </div>
    </CustodyEventDialogProvider>
  );
};

export default CustodyParentingIndex;
